// Lib
import React from 'react';
import HotTable from './HotTable';
import LegacyHotTable from './legacy/HotTable';
import { registerHotPlugins } from './hotPluginsRegistration';
import type { TableContentData } from '../../../common/table/TableTypes';

import './HotTableSwitch.scss';

// Register the plugins once globally
// TODO-TABLES - This can be moved to HotTable when the legacy implementation is removed
type HotTableProps = React.ComponentProps<typeof HotTable>;

export type HotTableSwitchProps = Omit<HotTableProps, 'tableContentData'> & {
    isV2Table: boolean;
    tableContentDataV2: TableContentData | undefined;
    // TODO-TABLES - These are legacy only props and can be removed when the legacy table is deprecated
    legacyCurrentCellSelections: object | null | undefined;
    isGridMoving: boolean;
    setIsGridMoving: (isMoving: boolean) => void;
};

registerHotPlugins();

const HotTableSwitch: React.FC<HotTableSwitchProps> = (props) => {
    const {
        isV2Table,
        tableContentDataV2,
        legacyCurrentCellSelections,
        isGridMoving,
        setIsGridMoving,
        ...hotTableProps
    } = props;

    if (isV2Table && tableContentDataV2) return <HotTable {...hotTableProps} tableContentData={tableContentDataV2} />;

    return (
        <LegacyHotTable
            {...hotTableProps}
            currentCellSelections={legacyCurrentCellSelections}
            isGridMoving={isGridMoving}
            setIsGridMoving={setIsGridMoving}
        />
    );
};

export default HotTableSwitch;
